export default __webpack_public_path__ + "c32b1a41ea9a4872d264d2f8e1c8c5a9.svg";